import { useAppStore } from "@/global/store";
import { selectUser } from "@/global/store/data/user";
import {
  Box,
  Divider,
  Link,
  ListItemIcon,
  ListItemText,
  MenuItem,
  MenuList,
} from "@mui/material";
import { AiOutlineDollarCircle } from "react-icons/ai";
import { HiOutlineTicket } from "react-icons/hi";
import { MdOutlineEventSeat, MdOutlinedFlag } from "react-icons/md";
import { TbShirtSport } from "react-icons/tb";
import OpenInNewRoundedIcon from "@mui/icons-material/OpenInNewRounded";

export const purchaseGiftCardLanguages = {
  pageTitle: "Give the gift of Diamondbacks Baseball",
  mainCardTitle: "Share a Gift",
  mainCardDescription:
    "Share the magic of Diamondbacks baseball with a friend or loved one. Upon purchase of the gift, a unique code will be generated for the intended recipient to redeem. Once redeemed, the gift is non-refundable.",
  amountTitle: "Gift Amount",
  recipientTitle: "Recipient",
  recipientEnabledDesc:
    "The Recipient will be sent an email with the unique code for them to redeem their gift. Once redeemed, the recipient will receive an account credit that they can use to purchase tickets for all Arizona Diamondbacks games at Chase Field.",
  recipientDisabledDesc:
    "If an intended recipient is not specified, once purchased, you will have to forward the unique code to the recipient. Upon your recipient receiving their gift, they will be prompted to enter their unique code to redeem the gift. Once redeemed, the recipient will receive an account credit that they use to purchase tickets for all Arizona Diamondbacks games at Chase Field.",
};

export const redeemGiftCardLanguages = {
  pageTitle: "Give the gift of Diamondbacks Baseball",
  mainCardTitle: "Redeem Gift",
  mainCardLoggedInDesc:
    "Please input the case sensitive code provided to redeem the value of the gift card to the Hippodrome Broadway Series in Baltimore account above.",
  mainCardLoggedOutDesc:
    "Please input the case sensitive unique code provided to redeem the value of the gift card to the Ticketmaster.",
  successDesc: "has been added to to your account!",
};

export const howItWorks = [
  {
    icon: <MdOutlinedFlag />,
    title: "Choose Your Games or Applicable Pack",
    description: "Select the pack you wish to purchase to choose your games.",
  },
  {
    icon: <MdOutlineEventSeat />,
    title: "Login to Account Manager",
    description:
      " Click Continue and connect your Arizona Diamondbacks account using our secure Ticketmaster login.",
  },
  {
    icon: <TbShirtSport />,
    title: "Select Your Seats",
    description: "Select the seats you wish to purchase for each game.",
  },

  {
    icon: <HiOutlineTicket />,
    title: "Get Your Tickets",
    description:
      "Tickets will be available in your Account Manager within 24 hours of redemption. Reach out to Live Fan Support for any questions.",
  },
];

export const faqs = [
  {
    title: "How does the Arizona Diamondbacks Flex program work?",
    description:
      "The Arizona Diamondbacks program allows fans to select any seat to select regular season games. Simply log into your Arizona Diamondbacks Account Manager and select games.",
  },
  {
    title: "Do I have to select all my games now?",
    description: "Yes, you must select all games at the time of purchase.",
  },
  {
    title: "Can I choose seats throughout the venue?",
    description: "Yes, you can choose from all current available inventory.",
  },
  {
    title: "Where are event tickets delivered?",
    description:
      "Event tickets are delivered directly within your Arizona Diamondbacks Account Manager.",
  },
];

export function TermsAndCondition() {
  return (
    <>
      By purchasing you agree to receive SMS alerts regarding ticket delivery
      and agree to the{" "}
      <Link
        // fontWeight={"bold"}
        // textDecor="underline"

        href={
          "https://uploads-ssl.webflow.com/5ed7df6fe67e862e0a62f9f2/616882d2b691e09f75348396_Terms%20%26%20Conditions.pdf"
        }
        target={"_blank"}
        sx={{
          color: "primary.main",
          textDecoration: "none",
          fontWeight: 500,
        }}
      >
        Terms & Conditions
      </Link>{" "}
      and{" "}
      <Link
        // fontWeight={"bold"}
        // textDecor="underline"
        href={
          "https://uploads-ssl.webflow.com/5ed7df6fe67e862e0a62f9f2/63c05d80816dac05b5b34ac7_seasonshare%20CCPA%20Privacy%20Policy%20Agreement.pdf"
        }
        target={"_blank"}
        sx={{
          color: "primary.main",
          textDecoration: "none",
          fontWeight: 500,
        }}
      >
        Privacy Policy
      </Link>
      .
    </>
  );
}
